<!--排行榜-->
<template>
  <div class="main-pc">
    <div class="title">{{$store.state.formTitle}}</div>
    <div class="main-box">
      <div class="top-line"></div>
      <div class="content-box">
        <img class="xian-l" src="../../assets/images/xian.png" alt="">
        <img class="xian-r" src="../../assets/images/xian.png" alt="">
        <div class="top">
          <div class="left-img">
            <img :src="myData.avatar" alt="" v-if="myData.avatar">
            <img src="../../assets/images/user_img.png" alt="" v-else>
          </div>
          <div class="right-text">
            <div class="text-l">
              <span>用户名</span>
              <span>{{myData.user_name}}</span>
            </div>
            <div class="text-r">
              <div class="p">
                <span><span class="fs">{{myData.score}}</span>分</span>
                <span>第 {{myData.ranking}} 名</span>
              </div>
              <img src="../../assets/images/jiangpei.png" alt="">
            </div>
          </div>
        </div>
        <div class="bottom">
          <div class="tab-title">
            <span class="ranking">名次</span>
            <span class="name">姓名</span>
            <span class="tel">手机号</span>
            <span class="fraction">分数</span>
          </div>
          <div class="tab-body">
            <Scroll :on-reach-bottom="handleReachBottom">
              <div class="tab-data" v-for="(item,index) in dataArr">
                <span class="ranking" v-if="index === 0"><img src="../../assets/images/one.png" alt=""></span>
                <span class="ranking" v-if="index === 1"><img src="../../assets/images/two.png" alt=""></span>
                <span class="ranking" v-if="index === 2"><img src="../../assets/images/three.png" alt=""></span>
                <span class="ranking"
                      v-if="index!==0 && index !==1 && index !==2 ">{{index+1}}</span>
                <span class="name">{{item.user_name}}</span>
                <span class="tel">{{item.mobile}}</span>
                <span class="fraction"><span>{{item.score}}</span>分</span>
              </div>
            </Scroll>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import {getRanking} from "../../api/Interface";

    export default {
        name: "ranking-pc",
        data() {
            return {
                tabHeight: 450,
                dataArr: [],
                myData: {},
                page: 1
            }
        },
        mounted() {
            this.getRankingData()
        },
        methods: {
            getRankingData() {
                let data = {
                    form_id: this.$route.query.id,
                    submit_id: this.$store.state.userInfoId,
                    pagesize: 30,
                    page: this.page
                }
                getRanking(data).then(res => {
                    if (res.state) {
                        this.dataArr = [...this.dataArr, ...res.data]
                        this.myData = res.my_result
                    }
                }).catch(error => {
                    console.log(error);
                })
            },

            handleReachBottom() {
                return new Promise(resolve => {
                    setTimeout(() => {
                        this.page++
                        this.getRankingData()
                        resolve();
                    }, 2000);
                });
            }
        }
    }
</script>
<style lang="scss" scoped>
  .main-pc {
    background: url("../../assets/images/bj_pc.png") no-repeat;
    background-size: cover;
    position: relative;

    .title {
      width: 100%;
      height: 75px;
      background: #ffffff;
      box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.04);
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      font-size: 22px;
      color: #303133;
      font-weight: bold;
      padding-left: 48px;
      line-height: 75px;
    }

    .main-box {
      width: 650px;
      height: 75%;
      /*background: #ffffff;*/
      border-radius: 8px;
      /*box-shadow: 0 2px 15px 0 #002e89;*/
      margin: auto;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      top: 163px;

      .top-line {
        width: 100%;
        height: 20px;
        background: #1a4bff;
        border: 4px solid #256eff;
        border-radius: 11px;
        box-shadow: 0px 2px 20px 0px rgba(0, 46, 137, 0.69);
        /*margin: 10px 10px 0 10px;*/
        position: relative;
        z-index: 999;
      }

      .content-box {
        width: 96%;
        height: calc(100% - 22px);
        display: block;
        position: relative;

        .xian-l, .xian-r {
          position: absolute;
          z-index: 9999;
          top: 72px;
          height: 40px;
        }

        .xian-l {
          left: 20px;
        }

        .xian-r {
          right: 20px;
        }

        .top {
          width: 100%;
          height: 92px;
          background-color: #ffffff;
          box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.1);
          position: relative;
          z-index: 999;
          margin-top: -8px;
          display: flex;
          padding: 0 0 0 50px;
          align-items: center;

          .left-img {
            width: 66px;
            height: 66px;
            flex-shrink: 0;

            img {
              border-radius: 50%;
            }
          }

          .right-text {
            height: 58px;
            color: #2F3246;
            font-size: 18px;
            font-weight: 500;
            flex: 1;
            display: flex;
            justify-content: space-between;

            .text-l {
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              align-items: inherit;
              padding-left: 12px;
              font-weight: 500;
              color: #2F3246;
            }

            .text-r {
              display: flex;
              justify-content: flex-end;

              .p {
                display: flex;
                flex-direction: column;
                align-items: flex-end;
                justify-content: space-between;

                .fs {
                  color: #FF6766;
                }
              }

              img {
                height: 120%;
                opacity: 0.15;
              }
            }
          }
        }

        .bottom {
          width: 100%;
          height: calc(100% - 109px);
          background-color: #ffffff;
          margin-top: 16px;
          border-radius: 0px 0px 8px 8px;
          box-shadow: 0px 2px 20px 0px rgba(0, 46, 137, 0.69);


          .tab-title {
            color: #C8C8C8;
            font-size: 20px;
            height: 65px;
            display: flex;
            align-items: center;
            justify-content: space-between;
          }

          .tab-body {
            height: calc(100% - 75px);

            /deep/ .ivu-scroll-wrapper {
              height: 100% !important;

              /deep/ .ivu-scroll-container {
                height: 100% !important;
                /*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
                &::-webkit-scrollbar {
                  width: 8px;
                  height: 8px;
                }
                /*定义滚动条轨道 内阴影+圆角*/
                &::-webkit-scrollbar-track {
                  background-color: #ffffff;
                }
                /*定义滑块 内阴影+圆角*/
                &::-webkit-scrollbar-thumb {
                  border-radius: 10px;
                  background-color: rgba(144, 147, 153, 0.3);
                }
              }
            }
          }

          .tab-data {
            color: #141414;
            font-size: 16px;
            height: 52px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-weight: 500;

            &:nth-child(odd) {
              background-color: #f8f9ff;
            }
          }

          .ranking {
            width: 150px;
            text-align: center;

            img {
              width: 22px;
              height: 22px;
            }
          }

          .name {
            flex: 1;
            text-align: center;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .tel {
            flex: 2;
            text-align: center;
          }

          .fraction {
            width: 150px;
            text-align: center;

            span {
              color: #FF6766;
            }
          }
        }
      }
    }
  }

</style>

